import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotePolicy } from '@core/models/interfaces/note';
import { NoteService } from '@core/services/note.service';
import { TranslateModule } from '@ngx-translate/core';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CheckboxModule } from 'primeng/checkbox';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayModule } from 'primeng/overlay';

@Component({
  selector: 'app-policy-multi-select-dropdown',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    InputTextModule,
    OverlayModule,
    InfiniteScrollDirective,
    IconFieldModule,
    InputIconModule,
    FloatLabelModule,
    CheckboxModule,
    SearchInputComponent,
    TranslateModule
  ],
  templateUrl: './policy-multi-select-dropdown.component.html',
  styleUrl: './policy-multi-select-dropdown.component.scss'
})
export class PolicyMultiSelectDropdownComponent {
  @Input() appendTo: 'body' | HTMLElement | undefined;
  @Input({ required: true }) policiesSelected: NotePolicy[] = [];
  @Input({ required: true }) totalPolicies: number = 0;
  @Input({ required: true }) policies: NotePolicy[] = [];
  @Input({ required: true }) label: string = '';
  @Input('leadIds') leadIds: string[] | undefined;
  @Input('policyIds') policyIds: string[] | undefined;
  
  @Output() policiesSelectedChange = new EventEmitter<NotePolicy[]>();
  
  keyword = '';
  page = 0;
  
  visible = false;
  
  constructor(
    private noteService: NoteService
  ) {}
  
  get selectedPoliciesString() {
    return this.policiesSelected.map(policy => policy.number).join(', ');
  }

  get policiesDrop() {
    return this.policies?.map(item => ({
      id: item.id,
      number: item.number
    }));
  }

  onScroll() {
    if (this.totalPolicies > this.policies.length) {
      this.page++;
      this.fetchPolicies('SCROLL');
    }
  }
  
  onPoliciesSelectedChange() {
    this.policiesSelectedChange.emit(this.policiesSelected);
  }
  
  fetchPolicies(type: 'SCROLL' | 'SEARCH') {
    this.noteService
      .getPolicyForNotesManagement({
        page: this.page,
        searchTerm: this.keyword,
        // leadIds: this.leadIds,
        // policyIds: this.policyIds
      })
      .subscribe({
        next: res => {
          this.totalPolicies = res.data.total;
          if (type === 'SCROLL') {
            this.policies = [...this.policies, ...res.data.content];
          }
          if (type === 'SEARCH') {
            this.policies = res.data.content;
          }
        }
      });
  }
  
  onSearch(keyword: string) {
    this.keyword = keyword;
    this.page = 0;
    this.fetchPolicies('SEARCH');
  }
}
